import { useEffect } from "react";
import { useAppSelector, useAppDispatch } from "../../hooks";
import type { RootState } from "../../store";
import { ChargeComponent } from "../../components/UI/ChargeComponent";
import { setPayment, onStartPaymentPoslink } from "../../store/payment";
import { PaymentProcessDetails } from "../../components/Order/Payment/PaymentProcessDetails";

export const PoslinkPayment = (): JSX.Element => {
  const dispatch = useAppDispatch();
  const getState = () => useAppSelector((state) => state); // NEEDS CHECKING

  const { station, payment, loading } = useAppSelector((state) => ({
    payment: state.payment.object,
    station: state.store.station,
    result: state.payment.result,
    loading: state.payment.loading,
  }));

  useEffect(() => {
    return () => {
      setPayment(null)(dispatch);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const sendingToDevice = loading;
  const disabled = sendingToDevice || !payment || payment.amount == 0;

  const onStartPayment = (state: RootState) => {
    setPayment({ amount: payment.amount })(dispatch);
    onStartPaymentPoslink(state)(dispatch);
  };

  return (
    <div>
      <ChargeComponent
        {...{
          sendingToDevice,
          disabled,
          device: station,
          onStart: onStartPayment,
        }}
      />
      <PaymentProcessDetails {...{ ...payment }} />
    </div>
  );
};
